<template>
    <div>
        <div class="popup__content" v-if="!showSendModal">
            <div class="add-worker__top mb24">
                <div class="text-size-l text-bold text-color" v-if="editUser.status">Пользователь <span v-if="editUser.banned">заблокирован {{editUser.dismissDate}}</span></div>
				<div class="text-size-l text-bold text-color" v-else>Новый пользователь</div>
            </div>
            <div style=" width: 100%;">
				<div class="flex-row mb16">
					<div style="width: 266px">
	                    <input-multi
	                         @chunk="setPersonInput"
	                         name="worker-name"
                             :disabled="editUser.banned || editUser.is_owner && editUser.id !== currentUser.id  && !currentUser.is_can_dismiss"
	                         :is-error="form.worker.name.error"
	                         :error-text="form.worker.name.errorText"
	                         v-model="form.worker.name.value"
	                         :fields="form.worker.name.fields"
	                         @focus="removeError(form.worker.name)"
                             :auto-focus="true"
	                         :placeholderInput="'Фамилия Имя Отчество'"
	                         @blur="blur(form.worker.name)"
	                         :placeholder="'Фамилия Имя Отчество'"></input-multi>
	                </div>
					<div style="width: 266px;">
	                    <input-styled
	                    name="worker-post"
	                    :placeholder="'Должность'"
                        :disabled="editUser.banned || editUser.is_owner && editUser.id !== currentUser.id  && !currentUser.is_can_dismiss"
	                    :placeholderInput="'Должность'"
	                    v-model="form.worker.post.value"
	                    @focus="form.worker.post.error=false"
	                    :is-error="form.worker.post.error">
	                    </input-styled>
	                </div>
                    <div style="width: 172px; height: 40px;">
                        <input-styled
                                v-if="editUser.banned || editUser.is_owner && editUser.id !== currentUser.id  && !currentUser.is_can_dismiss"
                                name="worker-post"
                                :placeholder="'Группа'"
                                :disabled="true"
                                :placeholderInput="'Группа'"
                                v-model="form.selectGroup.value"
                                @focus="form.selectGroup.error=false"
                                :is-error="form.selectGroup.error">
                        </input-styled>
                        <input-select
                                v-else
                                @change="form.selectGroup.error=false"
                                @open="form.selectGroup.error=false"
                                :tag="'div'"
                                :disabled="editUser.banned"
                                :isError="form.selectGroup.error"
                                v-model="form.selectGroup.value"
                                :options="selectOptionsDepartments"
                                :placeholder="'Группа'"
                                :list-style="{'max-height': 'none'}"></input-select>
                    </div>
				</div>
                <div class="flex-row mb16">
                    <div style="width: 172px;">
                        <input-styled
                        name="worker-phone"
                        :placeholder="'Телефон'"
                        :placeholderInput="'Телефон'"
                        :disabled="editUser.banned || editUser.is_owner && editUser.id !== currentUser.id  && !currentUser.is_can_dismiss"
                        v-model="form.worker.phone.value"
                        @focus="form.worker.phone.error=false"
                        :error-text="form.worker.phone.errorType === 'use' ? 'Этот номер уже существует':form.worker.phone.errorType === 'mobile' ? 'Только мобильные номера':''"
                        :is-error="form.worker.phone.error"
                        :mask="{mask:'+7(999)999-99-99',showMaskOnHover: false}">
                        </input-styled>
                    </div>

                    <div style="width: 172px">
                        <input-styled
                        name="worker-email"
                        :placeholder="'E-mail'"
                        :placeholderInput="'E-mail'"
                        :disabled="editUser.banned || editUser.is_owner && editUser.id !== currentUser.id  && !currentUser.is_can_dismiss"
                        v-model="form.worker.email.value"
                        :error-text="form.worker.email.errorType === 'use' ? 'Этот email уже существует':form.worker.email.errorType === 'rule' && form.worker.email.value.length ? 'Некорректный email':''"
                        @focus="form.worker.email.error=false"
                        :is-error="form.worker.email.error">
                        </input-styled>
                    </div>
                    <div style="width: 172px">
                        <input-styled
                                name="worker-email-work"
                                :placeholder="'Рабочий E-mail'"
                                :placeholderInput="'Рабочий E-mail'"
                                :disabled="editUser.banned || editUser.is_owner && editUser.id !== currentUser.id  && !currentUser.is_can_dismiss"
                                v-model="form.worker.emailWork.value"
                                :error-text="'Некорректный email'"
                                @focus="form.worker.emailWork.error=false"
                                :is-error="form.worker.emailWork.error">
                        </input-styled>
                    </div>
                    <div style="width: 172px;height: 40px;">
                        <input-styled
                                v-if="editUser.banned || !selectedDepartmentId || editUser.status != 'new' && editUser.id"
                                name="worker-post"
                                :placeholder="'Тип договора'"
                                :disabled="true"
                                :placeholderInput="'Тип договора'"
                                v-model="form.selectContract.value"
                                @focus="form.selectContract.error=false"
                                :is-error="form.selectContract.error">
                        </input-styled>
                        <input-select
                                v-else
                                @change="form.selectContract.error=false"
                                @open="form.selectContract.error=false"
                                :tag="'div'"
                                :disabled="editUser.banned || !selectedDepartmentId || editUser.status != 'new'"
                                :isError="form.selectContract.error"
                                v-model="form.selectContract.value"
                                :options="contractsGroupedOption"
                                :placeholder="'Тип договора'"
                                :list-style="{'max-height': 'none'}"></input-select>
                    </div>
                </div>
                <div class="add-worker__notify" v-if="editUser.banned">
                    <b>Для возвращения пользователя в работу обратитесь в отдел разработки сайтов</b>
                </div>
				<div class="add-worker__notify" v-else-if="!(currentUser.access_rights.is_owner || currentUser.is_can_dismiss) && editUser.status == 'active'">
					<b>Для редактирования прав доступа обратитесь к операционному директору.</b>
				</div>

                <div class="group-accesses" :class="{disabled: disabledCheckbox}">
					<div class="group-accesses__head df">
						<div class="text-size-xs text-color-grey text-uppercase" style="width: 316px;">
							Раздел
						</div>
						<div class="text-size-xs text-color-grey text-uppercase text-center" style="width: 140px;">
							нет доступа
						</div>
						<div class="text-size-xs text-color-grey text-uppercase text-center" style="width: 140px;">
							Читатель
						</div>
						<div class="text-size-xs text-color-grey text-uppercase text-center" style="width: 140px;">
							редактор
						</div>
					</div>
                    <template v-for="(i, index) in topSections">
                        <div class="group-accesses__item"  :key="i.id">
                            <span class="text-bold text-size-s name text-color-grey"
							:class="{'--reader': form.rights[i.id] === '1' || getCurrentUserRights(i.id) === '1',
							'--editor': form.rights[i.id] === '2' || getCurrentUserRights(i.id) === '2',
							'--chief': form.rights[i.id] === '28' || getCurrentUserRights(i.id) === '28'}">{{i.name}}</span>
							<right-radio-select
								@change="changeAccess($event, i.id)"
                                :value="getCurrentUserRights(i.id)"
								:index="index"
								:indexUser="i.id"
							></right-radio-select>
                        </div>
                    </template>
                </div>
				<div class="">
					<div class="checkbox mt24" :class="{disabled: disabledCheckbox}">
			            <input :disabled="disabledCheckbox" v-model="form.canDismiss.value" type="checkbox" id="canDismiss" name="canDismiss">
			            <label for="canDismiss">Может создавать и блокировать пользователей</label>
			        </div>

                    <div class="checkbox mt16" :class="{disabled: disabledCheckbox}">
                        <input :disabled="disabledCheckbox" v-model="form.isCanContactEdit.value" type="checkbox" id="isCanContactEdit" name="isCanContactEdit">
                        <label for="isCanContactEdit">Может создавать и редактировать партнёров</label>
                    </div>

                    <div class="checkbox mt16" :class="{disabled: disabledCheckbox}">
                        <input :disabled="disabledCheckbox" v-model="form.canContract.value" type="checkbox" id="canContract" name="canContract">
                        <label for="canContract">Может создавать и редактировать договора</label>
                    </div>

					<div class="checkbox mt16" :class="{disabled: disabledCheckbox}">
			            <input :disabled="disabledCheckbox" v-model="form.isTechWriter.value" type="checkbox" id="isTechWriter" name="isTechWriter">
			            <label for="isTechWriter">Технический писатель</label>
			        </div>

                    <div class="checkbox mt16" :class="{disabled: disabledCheckbox}">
                        <input :disabled="disabledCheckbox" v-model="form.isChef.value" type="checkbox" id="isChef" name="isChef">
                        <label for="isChef">Шеф-редактор</label>
                    </div>

				</div>
                <div v-if="editUser.doc && (editUser.status != 'new')">
                    <div class="checkbox" v-if="editUser.status == 'uploaded' && !showRight">
                        <input @input="form.worker.isCheckScan.error=false" :class="{error: form.worker.isCheckScan.error}" v-model="form.worker.isCheckScan.value" type="checkbox" id="isCheckScan" name="isCheckScan">
                        <label  for="isCheckScan">Я подтверждаю, что все скан-копии внимательно проверены</label>
                    </div>
                    <div class="checkbox mt32" v-if="editUser.status == 'approval'">
                        <input @input="form.worker.isCheckUser.error=false" :class="{error: form.worker.isCheckUser.error}" v-model="form.worker.isCheckUser.value" type="checkbox" id="isCheckUser" name="isCheckUser">
                        <label  for="isCheckUser">Я подтверждаю, что все данные пользователя внимательно проверены</label>
                    </div>
                    <div class="checkbox mt16" v-if="editUser.status == 'approval'">
                        <input @input="form.worker.isCheckRight.error=false" :class="{error: form.worker.isCheckRight.error}" v-model="form.worker.isCheckRight.value" type="checkbox" id="isCheckRight" name="isCheckRight">
                        <label  for="isCheckRight">Я подтверждаю, что все атрибуты и доступы внимательно проверены</label>
                    </div>
                </div>
            </div>
            <div class="row-b mt32">
                <div class="row-b__col elem-pos-fix mr24"   v-if="editUser.doc && (editUser.status != 'new') || !editUser.id">
                    <submit-btn class="" @click.native="send" :type="form.btnType">
                        <span class="i mr4" style="margin-top: -2px;" :class="{'i-ok7':form.btnType=='normal'}"></span>сохранить
                    </submit-btn>
                </div>
            </div>
			<div class="add-worker__link remove" v-if="editUser && editUser.id && !editUser.banned && !editUser.is_owner  && editUser.id !== currentUser.id && editUser.status == 'active'">
                <a @click="openUserDismiss" href="javascript:void(0);" class="link-icon link-icon__modal">
                    <span class="i i-stop5"></span>
                    <span class="text">Заблокировать</span>
                </a>
            </div>
			<div class="add-worker__link remove" v-if="editUser && editUser.id && !editUser.banned && !editUser.refuse && !editUser.is_owner  && (editUser.status == 'new' || editUser.status == 'uploaded')">
                <a @click="openUserRefuse" href="javascript:void(0);" class="link-icon link-icon__modal">
                    <span class="i i-stop5"></span>
                    <span class="text">Отклонить</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InputStyled from '@/components/forms/InputStyled.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import InputSelectNew from '@/components/forms/InputSelectNew.vue';
    import InputMulti from '@/components/forms/InputMulti.vue';
    import {scrollTo} from "@/helpers/animate";
	import RightRadioSelect from '@/components/forms/RightRadioSelect.vue';

    export default {
        name: "AddWorker",
        components: {
            InputStyled,
            SubmitBtn,
            InputSelect,
            InputMulti,
            InputSelectNew,
			RightRadioSelect
        },
        props: {
            usersGroupedCurrentIndex: {
                default: false
            }
        },
        mounted(){
            if(this.editUser.name){
                let fio = this.editUser.name.split(' ');
                this.form.worker.name.value = this.editUser.name;
                this.form.canDismiss.value = !!this.editUser.is_can_dismiss;
                this.form.canContract.value = !!this.editUser.is_can_contract;
                this.form.isTechWriter.value = !!this.editUser.is_tech_writer;
                this.form.isCanContactEdit.value = !!this.editUser.is_can_contact_edit;
                this.form.isChef.value = !!this.editUser.is_chef;
                this.form.worker.name.fields.lastName.value = fio[0];
                this.form.worker.name.fields.firstName.value = fio[1] ? fio[1] : ' ';
                this.form.worker.name.fields.secondName.value = fio[2] ? fio[2] : ' ';
            } else {
                if(this.formUser.firstName){
                    this.form.worker.name.value = this.formUser.lastName +' '+this.formUser.firstName+' '+this.formUser.secondName;
                    this.form.worker.name.fields.lastName.value = this.formUser.lastName;
                    this.form.worker.name.fields.firstName.value = this.formUser.firstName;
                    this.form.worker.name.fields.secondName.value = this.formUser.secondName;
                    this.form.worker.post.value = this.formUser.post;
                    this.form.worker.email.value = this.formUser.email;
                    this.form.worker.emailWork.value = this.formUser.emailWork;
                    this.form.worker.phone.value = this.formUser.phone;
                    if(this.formUser.department){
                        this.form.selectGroup.value = this.getOptionsDepartmentsName(this.formUser.department);
                    }
                    this.$nextTick(()=>{
                        if(this.formUser.contract){
                            this.form.selectContract.value = this.getOptionsContractName(this.formUser.contract);
                        }
                    })
                }
            }
            if(this.editUser.post){
                this.form.worker.post.value = this.editUser.post;
            }
            if(this.editUser.email){
                this.form.worker.email.value = this.editUser.email;
            }
            if(this.editUser.emailWork){
                this.form.worker.emailWork.value = this.editUser.emailWork;
            }
            if(this.editUser.phone){
                this.form.worker.phone.value = this.editUser.phone;
            }
            this.$nextTick(()=>{
                if(this.editUser.contract){
                    this.form.selectContract.value = this.getOptionsContractName(this.editUser.contract);
                }
            })
            if(this.editUser.department){
                this.form.selectGroup.value = this.getOptionsDepartmentsName(this.editUser.department);
            }
            if(this.editUser.id){
                for(let key in this.topSections){
                    let right = 0;
                    if(this.editUser.rights[this.topSections[key].id]){
                        if(this.editUser.rights[this.topSections[key].id] == 'R'){
                            right = 1;
                        }
                        if(this.editUser.rights[this.topSections[key].id] == 'W'){
                            right = 2;
                        }
                        if(this.editUser.rights[this.topSections[key].id] == 'C'){
                            right = 28;
                        }
                    }
                    this.$set(this.form.rights, this.topSections[key].id, right);
                }
            }
            else{
                for(let key in this.topSections){
                    this.$set(this.form.rights, this.topSections[key].id, 0);
                }
            }
        },
        data() {
            return {
                options: [
                  {name: '<span class=text-color-orange2>Читатель</span>', id: 1},
                  {name: '<span class=text-color-green>Редактор</span>', id: 2},
                  {name: '<span class=text-color-dark-blue>Модератор</span>', id: 28},
                  {name: '<span>Нет доступа</span>', id: 0}
                ],
                showSendModal: false,
                form:{
                    selectGroup: {
                        value: '',
                        error: false,
                    },
                    selectContract: {
                        value: '',
                        error: false,
                    },
                    selectAccess: {
                        id: 3,
                        error: false,
                    },
					canDismiss: {
						value: false,
					},
					canContract: {
						value: false,
					},
					isTechWriter: {
						value: false,
					},
					isCanContactEdit: {
						value: false,
					},
                    isChef: {
						value: false,
					},

                    worker: {
                        name: {
                            name: 'workerName',
                            value: '',
                            fields: {
                                lastName: {
                                    name: 'lastName',
                                    value: '',
                                    delimiter: ' ',
                                    placeholder: 'Фамилия',
                                },
                                firstName: {
                                    name: 'firstName',
                                    value: '',
                                    delimiter: ' ',
                                    placeholder: 'Имя',
                                },
                                secondName: {
                                    name: 'secondName',
                                    value: '',
                                    delimiter: '',
                                    placeholder: 'Отчество',
                                },
                            },
                            required: true,
                            error: false,
                            errorText: '',
                            disabled: false,
                            focus:false,
                            sortScroll: 7
                        },
                        post: {
                            value: '',
                            error: false,
                        },
                        phone: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },
                        email: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },
                        emailWork: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },
                        isCheckScan: {
                            value: false,
                            error: false,
                        },
                        isCheckUser: {
                            value: false,
                            error: false,
                        },
                        isCheckRight: {
                            value: false,
                            error: false,
                        },
                    },
                    rights:{},
                    notifyWorker: {
                        value: false,
                        error: false,
                    },
                    btnType: 'normal',
                },
                showRight: false,
            }
        },
        methods: {
			openPdfViewer(number){
                window.open(process.env.VUE_APP_PATH_FRONT + '/rules/staff-doc/' + this.editUser.id + '/' + number + '/', '_blank');
			},
			getCurrentUserRights: function (sectionId) {
			  let rights = {
					'W': '2',
					'R': '1',
					'C': '28',
				  },
				  result = 0;

			  if (this.editUser.rights && rights[this.editUser.rights[sectionId]]) {
				result = rights[this.editUser.rights[sectionId]];
			  }

			  return result;
			},

			changeAccess: function(event, index){
                this.form.rights[index] = event;
            },
            setPersonInput: function (field) {
                if(field.value !== undefined && field.name !== undefined){
                    this.form.worker.name.fields[field.name].value = field.value;
                }
            },
            blur(field){
                field.focus = false;
            },
            removeError: function(field) {
                field.error = false;
                field.focus = true;
            },
            close(){
                this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                //На всякий случай очистим данные для редактирования раздела
                this.$store.commit('rulesStaff/setEditUser',[]);
                if(this.editUser.id){
                    this.$nextTick(()=>{
                        scrollTo('#user_'+this.this.editUser.id);
                    })
                }
            },
            send(){
                if(this.editUser.banned){
                    this.close();
                } else {
                    let error = false;
                    this.form.worker.phone.errorType = 'empty';
                    this.form.worker.email.errorType = 'empty';

                    if(!this.form.selectGroup.value || this.form.selectGroup.value.length == 0){
                        if(this.form.selectGroup.error){
                            this.form.selectGroup.error = false;
                            setTimeout(() => {
                                this.form.selectGroup.error = true;
                            });
                        }else{
                            this.form.selectGroup.error = true;
                        }
                        error = true;
                    }
                    if(this.form.worker.name.value.length == 0){
                        this.repeatFieldError('name');
                        error = true;
                    } else {
                        for(let n in this.form.worker.name.fields){
                            if(this.form.worker.name.fields[n].value.length == 0){
                                this.repeatFieldError('name');
                                error = true;
                            }
                        }
                    }
                    if(this.form.worker.post.value.length == 0){
                        this.repeatFieldError('post');
                        error = true;
                    }
                    if(!this.form.worker.isCheckScan.value && this.editUser.status == 'uploaded' && !this.showRight){
                        this.repeatFieldError('isCheckScan');
                        error = true;
                    }
                    if(!this.form.worker.isCheckUser.value && this.editUser.status == 'approval'){
                        this.repeatFieldError('isCheckUser');
                        error = true;
                    }
                    if(!this.form.worker.isCheckRight.value && this.editUser.status == 'approval'){
                        this.repeatFieldError('isCheckRight');
                        error = true;
                    }
                    if(this.form.worker.phone.value.length == 0){
                        this.repeatFieldError('phone');
                        error = true;
                    } else {
                        let phone = this.form.worker.phone.value.replace(/[^\+0-9]/g, '');
                        if (phone.length < 12) {
                            error = true;
                            this.repeatFieldError('phone');
                            if(phone.length > 0){
                                this.form.worker.phone.errorType = 'mobile';
                            }
                        } else if (phone[2] != '9') {
                            error = true;
                            this.repeatFieldError('phone');
                            this.form.worker.phone.errorType = 'mobile';
                        }
                    }
                    let rEmail = /^[\w\.\d-_]+@[\w\.\d-_]+\.\w{2,99}$/i;
                    if(this.form.worker.email.value.length == 0 || !rEmail.test(this.form.worker.email.value)){
                        this.repeatFieldError('email');
                        if(!rEmail.test(this.form.worker.email.value)){
                            this.form.worker.email.errorType = 'rule';
                        }
                        error = true;
                    }


                    if(!error){
                        this.form.btnType = 'load';
                        let params = {
                            id: this.editUser.id ? this.editUser.id : false,
                            form:{
                                department: this.selectedDepartmentId,
                                contract: this.selectedContractId,
                                firstName: this.form.worker.name.fields.firstName.value,
                                lastName: this.form.worker.name.fields.lastName.value,
                                secondName: this.form.worker.name.fields.secondName.value,
                                post: this.form.worker.post.value,
                                phone: this.form.worker.phone.value,
                                email: this.form.worker.email.value,
                                emailWork: this.form.worker.emailWork.value,
                                canDismiss: this.form.canDismiss.value,
                                canContract: this.form.canContract.value,
                                isTechWriter: this.form.isTechWriter.value,
                                isCanContactEdit: this.form.isCanContactEdit.value,
                                isChef: this.form.isChef.value,
                                type: 'saveUser',
                                rights: JSON.stringify(this.form.rights)
                            }
                        };

                        this.$store.dispatch('rulesStaff/addUser', params).then((result)=>{
                            this.form.btnType = 'normal';
                            this.$emit('change', this.selectedDepartmentId);
                            if(result.status == 'error'){
                                for(let e in result.statusErrors) {
                                    if(result.statusErrors[e] == 'phoneIsUsed'){
                                        this.repeatFieldError('phone');
                                        this.form.worker.phone.errorType = 'use';
                                    }
                                    if(result.statusErrors[e] == 'emailIsUsed'){
                                        this.repeatFieldError('email');
                                        this.form.worker.email.errorType = 'use';
                                    }
                                }
                            } else {
                                this.close();
                            }
                        });
                    }
                }

            },
            openRefuse(){
                this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                this.$store.dispatch('popups/open', {name: this.popups.userRefuse.name});
            },
            userBanned(){
                if(this.editUser.id){
                    this.$store.dispatch('rulesStaff/userBanned', {id: this.editUser.id});
                    this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                }
            },
            userUnBanned(){
                if(this.editUser.id) {
                    this.$store.dispatch('rulesStaff/userUnBanned', {id: this.editUser.id});
                    this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                }
            },
            userDelete(){
                if(this.editUser.id) {
                    this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                    this.$store.commit('popups/open', {name: this.popups.dismissWorker.name});
                }
            },
			openUserDismiss(){
                if(this.editUser.id) {
                    this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                    this.$store.commit('popups/open', {name: this.popups.dismissWorker.name});
                }
            },
            openUserRefuse(){
                if(this.editUser.id) {
                    this.$store.commit('popups/close', {name: this.popups.addWorker.name});
                    this.$store.commit('popups/open', {name: this.popups.refuseWorker.name});
                }
            },
            getOptionsDepartmentsName(id){
                let this_ = this, result;

                this.usersGrouped.forEach(function(item, i, arr) {
                    if(item.id == id){
                        result = item.name;
                        return false;
                    }
                });

                return result;
            },
            getOptionsContractName(id){
                let this_ = this, result;
                let group = [];
                for(let g in this.contractsGrouped){
                    if(this.contractsGrouped[g].id == this.editUser.department ){
                        group = this.contractsGrouped[g].contracts
                    }
                }
                if(group.length == 0){
                    for(let g in this.contractsGrouped){
                        if(this.contractsGrouped[g].id == this.formUser.department ){
                            group = this.contractsGrouped[g].contracts
                        }
                    }
                }
                group.forEach(function(item, i, arr) {
                    if(item.id == id){
                        result = item.title;
                        return false;
                    }
                });

                return result;
            },
            repeatFieldError(field){
                if(this.form.worker[field].error){
                    this.form.worker[field].error = false;
                    setTimeout(() => {
                        this.form.worker[field].error = true;
                    });
                }else{
                    this.form.worker[field].error = true;
                }
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                usersGrouped: state => state.rulesStaff.usersByDepartmentList,
                topSections: state => state.rules.topSectionsStaff,
                editUser: state => state.rulesStaff.editUser,
                currentUser: state => state.users.user,
                contractsGrouped: state => state.contracts.items,
                formUser: state => state.rulesStaff.form,
            }),
            contractsGroupedOption(){
                let group = [];
                for(let g in this.contractsGrouped){
                    if(this.contractsGrouped[g].id == this.selectedDepartmentId ){
                        group = this.contractsGrouped[g].contracts
                    }
                }
                let result = [];
                group.forEach(function(item, i, arr) {
                    result.push(item.title);
                });
                return result;
            },
            contractsGroupedCurrent(){
                let group = [];
                for(let g in this.contractsGrouped){
                    if(this.contractsGrouped[g].id == this.selectedDepartmentId ){
                        group = this.contractsGrouped[g].contracts
                    }
                }
                return group;
            },
            admins(){
                let admins = [];
                for(let g in this.usersGrouped){
                    for(let u in this.usersGrouped[g].users){
                        if(this.usersGrouped[g].users[u].is_owner && this.usersGrouped[g].users[u].name != 'Админ Тестовый'){
                            admins.push(this.usersGrouped[g].users[u])
                        }
                    }
                }
                return admins;
            },
            selectOptionsDepartments(){
                let result = [];
                this.usersGrouped.forEach(function(item, i, arr) {
                    result.push(item.name);
                });
                return result;
            },
            selectedDepartmentId(){
                let this_ = this, result;

                this.usersGrouped.forEach(function(item, i, arr) {
                    if(item.name == this_.form.selectGroup.value){
                        result = item.id;
                        return false;
                    }
                });
                return result;
            },
            selectedContractId(){
                let this_ = this, result;

                this.contractsGroupedCurrent.forEach(function(item, i, arr) {
                    if(item.title == this_.form.selectContract.value){
                        result = item.id;
                        return false;
                    }
                });
                return result;
            },
            disabledCheckbox(){
                return (!(this.currentUser.access_rights.is_owner || this.currentUser.is_can_dismiss) || this.editUser.banned || (this.editUser.is_owner && this.editUser.id !== this.currentUser.id)) && !(this.currentUser.is_can_dismiss && this.editUser.status != 'active')
            }
        },
    }
</script>

<style scoped>

</style>
